import { Box } from '@material-ui/core';
import React, { useState } from 'react';
import KenCard from '../../../../../../global_components/KenCard';
import KenSelectWrap from '../../../../../../global_components/KenSelect';
import DefaultGradingAbsolute from './DefaultGradingAbsolute';
import DefaultGradingRelative from './DefaultGradingRelative';

const selectOptionsCourse = [
  {
    label: 'ABSOLUTE',
    value: 'Absolute',
  },
  {
    label: 'RELATIVE',
    value: 'relative',
  },
];

const GradingSettings = () => {
  const [selectValueCourse, setSelectValueCourse] = useState(
    selectOptionsCourse[0].value
  );
  const handleSelectChangeCourse = (e) => {
    setSelectValueCourse(e.target.value);
  };
  return (
    <div>
      <Box>
        <KenSelectWrap
          label="Grading Methods :"
          options={selectOptionsCourse}
          value={selectValueCourse}
          dropdownColor="#FFFFFF"
          onChange={handleSelectChangeCourse}
          required
        />
      </Box>
      <KenCard>
        {selectValueCourse === 'Absolute' && <DefaultGradingAbsolute />}
        {selectValueCourse === 'relative' && <DefaultGradingRelative />}
      </KenCard>
    </div>
  );
};

export default GradingSettings;
